/* ─────────────────────────────────────────────────────────────────────────────
   PGA Yorkshire — Image Reveal Sweep
   ─────────────────────────────────────────────────────────────────────────────

   HOW TO USE
   ──────────
   Add data-reveal-sweep to any element that wraps an <img>.
   A coloured bar sweeps in from the left to cover the image, then exits to
   the right — revealing the image beneath.

     <div class="my-image-wrapper" data-reveal-sweep>
       <img src="..." />
     </div>

   Options (all optional):
     data-reveal-sweep-color="#111111"   bar colour (default #111111)
     data-reveal-sweep-delay="200"       delay before sweep starts, in ms

   Automatically disabled for prefers-reduced-motion users.
   ─────────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ATTR          = 'data-reveal-sweep';
  var COLOR_ATTR    = 'data-reveal-sweep-color';
  var DELAY_ATTR    = 'data-reveal-sweep-delay';
  var DEFAULT_COLOR = '#111111';
  var PHASE1        = 380;   /* ms — bar sweeps in */
  var PAUSE         = 30;    /* ms — gap between phases */
  var PHASE2        = 380;   /* ms — bar exits */
  var EASE          = 'cubic-bezier(0.77, 0, 0.18, 1)';

  /* ── One-time global styles ────────────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('pga-image-reveal-styles')) return;
    var s = document.createElement('style');
    s.id = 'pga-image-reveal-styles';
    s.textContent = [
      '/* image-reveal.js */                    ',
      '[data-reveal-sweep] {                     ',
      '  position: relative;                     ',
      '  overflow: hidden;                       ',
      '}                                         ',
      '[data-reveal-sweep] img {                 ',
      '  opacity: 0;                             ',
      '  transition: opacity 0s;                 ',
      '}                                         ',
      '[data-reveal-sweep].ir-done img {         ',
      '  opacity: 1;                             ',
      '}                                         ',
      '.ir-bar {                                 ',
      '  position: absolute;                     ',
      '  inset: 0;                               ',
      '  z-index: 2;                             ',
      '  pointer-events: none;                   ',
      '  transform: scaleX(0);                   ',
      '  transform-origin: left center;          ',
      '}                                         ',
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── Animate one element ───────────────────────────────────────────────── */
  function animateEl(el) {
    if (el._irDone) return;
    el._irDone = true;

    var color  = el.getAttribute(COLOR_ATTR) || DEFAULT_COLOR;
    var delay  = parseInt(el.getAttribute(DELAY_ATTR), 10) || 0;

    var bar = document.createElement('div');
    bar.className = 'ir-bar';
    bar.style.background  = color;
    bar.style.transition  = 'transform 0s';
    el.appendChild(bar);

    /* Two rAF calls ensure the initial state is painted before we transition */
    function startSweep() {
      /* ── Phase 1: bar sweeps IN from the left ─── */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.transition     = 'transform ' + PHASE1 + 'ms ' + EASE;
          bar.style.transformOrigin = 'left center';
          bar.style.transform      = 'scaleX(1)';

          setTimeout(function () {
            /* Reveal image now (hidden behind full bar, so change is invisible) */
            el.classList.add('ir-done');

            /* ── Phase 2: bar exits to the right ─── */
            bar.style.transition     = 'transform ' + PHASE2 + 'ms ' + EASE;
            bar.style.transformOrigin = 'right center';

            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                bar.style.transform = 'scaleX(0)';

                setTimeout(function () {
                  /* Clean up — bar no longer needed */
                  if (bar.parentNode) bar.parentNode.removeChild(bar);
                }, PHASE2 + 60);
              });
            });
          }, PHASE1 + PAUSE);
        });
      });
    }

    if (delay > 0) {
      setTimeout(startSweep, delay);
    } else {
      startSweep();
    }
  }

  /* ── Observe + trigger ─────────────────────────────────────────────────── */
  function init(root) {
    root = root || document;
    var els = root.querySelectorAll('[' + ATTR + ']');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          animateEl(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(els, function (el) {
      observer.observe(el);
    });
  }

  /* ── Boot ──────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { injectStyles(); init(); });
  } else {
    injectStyles();
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.ImageReveal = { refresh: init };
})();
